<form [formGroup]="form"
      (ngSubmit)="create()">
  <div class="formgrid grid mx-4 mt-3">
    <div class="field col-6 mb-4">
      <label for="firstName"
             class="font-bold sc-required-input"
             i18n>First Name</label>
      <input scValidatable
             id="firstName"
             type="text"
             pInputText
             formControlName="firstName"
             placeholder="Enter first name"
             i18n-placeholder
             class="w-full">
    </div>

    <div class="field col-6 mb-4">
      <label for="lastName"
             class="font-bold sc-required-input"
             i18n>Last Name</label>
      <input scValidatable
             id="lastName"
             type="text"
             pInputText
             formControlName="lastName"
             placeholder="Enter last name"
             i18n-placeholder
             class="w-full">
    </div>

    <div class="field col-12 mb-4">
      <label for="email"
             class="font-bold sc-required-input"
             i18n>Email</label>
      <input scValidatable
             id="email"
             type="email"
             pInputText
             formControlName="email"
             placeholder="Enter email"
             i18n-placeholder
             class="w-full">
    </div>

    <div class="field col-6 mb-4">
      <label for="title"
             class="font-bold"
             i18n>Title</label>
      <p-select id="title"
                [options]="titles$ | async"
                [showClear]="true"
                formControlName="title"
                placeholder="Choose title"
                appendTo="body"
                i18n-placeholder
                styleClass="w-full"></p-select>
    </div>

    <div class="field col-6 mb-4">
      <label for="orcidId"
             class="font-bold"
             i18n>ORCID iD</label>
      <p-inputMask mask="9999-9999-9999-999a"
                   characterPattern="[0-9X]"
                   id="orcidId"
                   scValidatable
                   formControlName="orcidId"
                   placeholder="Enter ORCID iD, e.g. 0000-0002-1825-0097"
                   i18n-placeholder
                   styleClass="w-full">
      </p-inputMask>
    </div>

    <div class="field col-6 mb-4">
      <label for="universityOrOrganization"
             class="font-bold sc-required-input"
             i18n>University/Organization</label>
      <sc-grid-autocomplete inputId="universityOrOrganization"
                            scValidatable
                            formControlName="universityOrOrganization"
                            placeholder="Find university/organization"
                            (organizationSelected)="fillAddressFromGrid($event)"
                            inputStyleClass="w-full"
                            styleClass="w-full">
      </sc-grid-autocomplete>
    </div>

    <div class="field col-6 mb-4">
      <label for="department"
             class="font-bold"
             i18n>Department</label>
      <input scValidatable
             id="department"
             type="text"
             pInputText
             formControlName="department"
             placeholder="Enter department"
             i18n-placeholder
             class="w-full">
    </div>

    <div class="field col-6 mb-4">
      <label for="countryId"
             class="font-bold sc-required-input"
             i18n>Country</label>
      <p-select scValidatable
                id="countryId"
                [options]="countries$ | async"
                [virtualScroll]="true"
                [virtualScrollItemSize]="50"
                [showClear]="true"
                [filter]="true"
                placeholder="Choose country"
                i18n-placeholder
                appendTo="body"
                formControlName="countryId"
                styleClass="w-full"></p-select>
    </div>

    <div class="field col-6 mb-4">
      <label for="city"
             class="font-bold"
             i18n>City</label>
      <input scValidatable
             id="city"
             type="text"
             pInputText
             formControlName="city"
             placeholder="Enter city"
             i18n-placeholder
             class="w-full">
    </div>

    <div class="field col-6 mb-4">
      <label for="addressLine1"
             class="font-bold"
             i18n>Address Line 1</label>
      <input scValidatable
             id="addressLine1"
             type="text"
             pInputText
             formControlName="addressLine1"
             placeholder="Enter Address Line 1"
             i18n-placeholder
             class="w-full">
    </div>

    <div class="field col-6 mb-4">
      <label for="zip"
             class="font-bold"
             i18n>ZIP</label>
      <input scValidatable
             id="zip"
             type="text"
             pInputText
             formControlName="zip"
             placeholder="Enter ZIP"
             i18n-placeholder
             class="w-full">
    </div>
  </div>

  <p-button scSubmitButton
            [requestInProcess]="requestInProcess"
            class="flex justify-content-center mt-3"
            label="Create"
            i18n-label>
  </p-button>
</form>